webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(300);
	
	var _elementUi = __webpack_require__(275);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuefire = __webpack_require__(340);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _vueRouter = __webpack_require__(339);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueDataTables = __webpack_require__(318);
	
	var _vueDataTables2 = _interopRequireDefault(_vueDataTables);
	
	var _store = __webpack_require__(51);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _helpers = __webpack_require__(5);
	
	var _App = __webpack_require__(319);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Login = __webpack_require__(322);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Reset = __webpack_require__(326);
	
	var _Reset2 = _interopRequireDefault(_Reset);
	
	var _Confirm = __webpack_require__(320);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Users = __webpack_require__(328);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _User = __webpack_require__(327);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Projects = __webpack_require__(325);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _Project = __webpack_require__(324);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _NotFound = __webpack_require__(323);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuefire2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueDataTables2.default);
	
	function loginRequired(to, from, next) {
	  if (_helpers.authService.authenticated()) {
	    next();
	  } else {
	    router.push('/');
	  }
	}
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '/', components: { default: _Projects2.default, entry: _Login2.default } }, { path: '/reset', components: { default: _Projects2.default, entry: _Reset2.default } }, { path: '/confirm-password', components: { default: _Projects2.default, entry: _Confirm2.default } }, { path: '/users', component: _Users2.default, beforeEnter: loginRequired }, { path: '/users/:id', component: _User2.default, beforeEnter: loginRequired }, { path: '/projects', component: _Projects2.default, beforeEnter: loginRequired }, { path: '/projects/:id', component: _Project2.default, beforeEnter: loginRequired }, { path: '*', component: _NotFound2.default }],
	  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	    next(function (vm) {
	      vm.activeLink = to.path;
	    });
	  },
	  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
	    this.activeLink = to.path;
	    next();
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  router: router,
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authService = exports.db = undefined;
	
	var _promise = __webpack_require__(232);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _firebase = __webpack_require__(303);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _store = __webpack_require__(51);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: 'AIzaSyAnIsXqF3IS-biSrFuW1UsZwCpfMcjJjkQ',
	  authDomain: 'fir-project-797ad.firebaseapp.com',
	  databaseURL: 'https://fir-project-797ad.firebaseio.com',
	  projectId: 'fir-project-797ad',
	  storageBucket: 'fir-project-797ad.appspot.com',
	  messagingSenderId: '353809081261'
	};
	
	var firebaseApp = _firebase2.default.initializeApp(config);
	var db = firebaseApp.database();
	
	var initializeAuth = new _promise2.default(function (resolve) {
	  _firebase2.default.auth().onAuthStateChanged(function (user) {
	    authService.setUser(user);
	    resolve(user);
	  });
	});
	
	var authService = {
	
	  user: null,
	
	  authenticated: function authenticated() {
	    return initializeAuth.then(function (user) {
	      return user;
	    });
	  },
	  setUser: function setUser(user) {
	    if (user) {
	      _store2.default.dispatch('setUser', user);
	    } else {
	      _store2.default.dispatch('setUser', null);
	    }
	    this.user = user;
	  },
	  userCreate: function userCreate(email, password) {
	    return _firebase2.default.auth().createUserWithEmailAndPassword(email, password).then(function () {
	      var user = _firebase2.default.auth().currentUser;
	      if (user) {
	        db.ref('users/' + user.uid).set({
	          email: user.email,
	          isAdmin: false
	        });
	      } else {
	        console.log('There is no current user');
	      }
	    }).catch(function (error) {
	      window.alert(error.message);
	    }).then(function () {
	      return _firebase2.default.auth().signOut().then(function () {
	        window.location.href = '/';
	      });
	    });
	  },
	  userDelete: function userDelete(uid) {
	    db.ref('users/' + uid).remove();
	    window.location.href = '/#/users';
	  },
	  login: function login(email, password) {
	    return _firebase2.default.auth().signInWithEmailAndPassword(email, password).then(function () {}).catch(function (error) {
	      window.alert(error.message + ' Contact platform@marcastudio.com for more details.');
	    });
	  },
	  logout: function logout() {
	    return _firebase2.default.auth().signOut().then(function () {
	      window.location.href = '/';
	    });
	  },
	  reset: function reset(email) {
	    return _firebase2.default.auth().sendPasswordResetEmail(email).then(function () {
	      window.alert('Password Reset Email Sent!');
	      window.location.href = '/';
	    }).catch(function (error) {
	      window.alert(error.message + ' Contact platform@marcastudio.com for more details.');
	    });
	  },
	  setNewPassword: function setNewPassword() {
	    var urlParams = new URLSearchParams(window.location.search);
	    console.log(urlParams.get('mode'));
	    console.log(urlParams.get('oobCode'));
	    console.log(urlParams.get('apiKey'));
	  }
	};
	
	exports.db = db;
	exports.authService = authService;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(193);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  currentUser: {},
	  userMeta: {}
	};
	
	var mutations = {
	  SET_USER: function SET_USER(state, user) {
	    if (user) {
	      state.currentUser = user;
	      _helpers.db.ref('users/' + user.uid).once('value').then(function (s) {
	        state.userMeta = s.val();
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }
	};
	
	var actions = {
	  setUser: function setUser(_ref, user) {
	    var commit = _ref.commit;
	
	    commit('SET_USER', user);
	  }
	};
	
	var store = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  actions: actions
	});
	
	exports.default = store;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _json2csv = __webpack_require__(308);
	
	var _json2csv2 = _interopRequireDefault(_json2csv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (data, fields, fieldNames, fileName) {
	  try {
	    var result = (0, _json2csv2.default)({
	      data: data,
	      fields: fields,
	      fieldNames: fieldNames
	    });
	    var encodedUri = encodeURI(result);
	    var link = document.createElement('a');
	    link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodedUri);
	    link.setAttribute('download', (fileName || 'file') + '.csv');
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);
	  } catch (err) {
	    console.error(err);
	  }
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(321);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	
	  data: function data() {
	    return {
	      auth: _helpers.authService
	    };
	  },
	
	
	  components: {
	    AppHeader: _Header2.default
	  }
	};

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(5);
	
	exports.default = {
	  name: 'confirm',
	
	  data: function data() {
	    return {
	      dataReady: false,
	      auth: _helpers.authService
	    };
	  },
	
	
	  components: {},
	
	  created: function created() {
	    this.auth.setNewPassword();
	    this.dataReady = true;
	  }
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(5);
	
	var _vuex = __webpack_require__(193);
	
	exports.default = {
	  name: 'header',
	
	  data: function data() {
	    return {
	      activeIndex: '1',
	      activeIndex2: '2',
	      auth: _helpers.authService
	    };
	  },
	
	  computed: (0, _vuex.mapState)(['currentUser', 'userMeta']),
	  methods: {
	    logOut: function logOut() {
	      this.auth.logout();
	    }
	  }
	
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      labelPosition: 'top',
	      auth: _helpers.authService,
	      loginForm: {
	        email: '',
	        pass: ''
	      },
	      resetForm: {
	        email: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter you email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }],
	        pass: [{ required: true, message: 'Please enter your password', trigger: 'blur' }, { min: 6, message: 'Your password is too short!' }]
	      }
	    };
	  },
	
	  methods: {
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var email = _this.loginForm.email;
	          var pass = _this.loginForm.pass;
	          _this.auth.login(email, pass);
	          _this.loginForm.email = '';
	          _this.loginForm.pass = '';
	        } else {
	          console.log('There was an error!');
	          return false;
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(229);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _stringify = __webpack_require__(230);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _set = __webpack_require__(233);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _CsvExport = __webpack_require__(218);
	
	var _CsvExport2 = _interopRequireDefault(_CsvExport);
	
	var _PapaParse = __webpack_require__(195);
	
	var _PapaParse2 = _interopRequireDefault(_PapaParse);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _slugify = __webpack_require__(190);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _en = __webpack_require__(278);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _locale = __webpack_require__(28);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_locale2.default.use(_en2.default);
	var projectRef;
	exports.default = {
	  name: 'project',
	  data: function data() {
	    return {
	      dataReady: false,
	      auth: _helpers.authService,
	      uid: '',
	      options: [{
	        value: 'Available',
	        label: 'Available'
	      }, {
	        value: 'Held',
	        label: 'Held'
	      }, {
	        value: 'Sold',
	        label: 'Sold'
	      }, {
	        value: 'Future',
	        label: 'Future'
	      }],
	      value: '',
	      formInline: {
	        user: '',
	        unitFile: ''
	      },
	
	      dialogFormVisible: false,
	      deleteFormVisible: false,
	      labelPosition: 'top',
	      form: {
	        id: '',
	        unitnum: '',
	        floor: '',
	        unit: '',
	        size: '',
	        size2: '',
	        plan: '',
	        type: '',
	        file: '',
	        plate: '',
	        price: '',
	        status: '',
	        view: ''
	      }
	    };
	  },
	  created: function created() {
	    this.$bindAsObject('user', _helpers.db.ref('users').child(this.auth.user.uid));
	    projectRef = _helpers.db.ref(this.$route.path);
	    this.$bindAsObject('project', projectRef);
	    this.dataReady = true;
	  },
	
	
	  methods: {
	    deleteProject: function deleteProject() {
	      this.$firebaseRefs.project.remove();
	      this.deleteFormVisible = false;
	      this.$router.push('/projects');
	    },
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    },
	    setDate: function setDate() {
	      var timeStamp = Date.now();
	      this.$firebaseRefs.project.child('edited').set(timeStamp);
	      this.$firebaseRefs.project.child('mostRecent').set(-Math.abs(timeStamp));
	    },
	    updateName: function updateName() {
	      var newName = this.project.name;
	      this.$firebaseRefs.project.child('name').set(newName);
	      this.$firebaseRefs.project.child('slug').set((0, _slugify2.default)(newName.toLowerCase()));
	      this.setDate();
	    },
	    updateFile: function updateFile(e) {
	      var vm = this;
	      _PapaParse2.default.parse(e.target.files[0], {
	        header: true,
	        complete: function complete(results, file) {
	          vm.$firebaseRefs.project.child('units').set(results.data);
	          vm.setDate();
	        }
	      });
	      e.target.value = '';
	      vm.availPlans();
	    },
	    handlePreview: function handlePreview(file, fileList) {
	      console.log(file, 'handle preview');
	    },
	    handleRemove: function handleRemove(file, fileList) {
	      console.log(file, fileList);
	    },
	    handleFilterDataChange: function handleFilterDataChange(filteredData) {
	      this.filteredData = filteredData;
	    },
	    updateUnits: function updateUnits() {
	      this.$firebaseRefs.project.child('units').set(this.project.units);
	      this.setDate();
	      this.dialogFormVisible = false;
	      this.availPlans();
	    },
	    availPlans: function availPlans() {
	      var units = this.$firebaseRefs.project.child('units');
	      var allPlans = new _set2.default();
	      var notSoldPlans = new _set2.default();
	
	      units.on('value', function (snapshot) {
	        snapshot.forEach(function (childSnapshot) {
	          var childData = childSnapshot.val();
	          allPlans.add((0, _stringify2.default)({ 'file': childData.file, 'plan': childData.plan, 'size': childData.size, 'size2': childData.size2, 'type': childData.type, 'status': 'Sold' }));
	        });
	      });
	
	      units.on('value', function (snapshot) {
	        snapshot.forEach(function (childSnapshot) {
	          var childData = childSnapshot.val();
	          if (childData.status !== 'Sold') {
	            notSoldPlans.add((0, _stringify2.default)({ 'file': childData.file, 'plan': childData.plan, 'size': childData.size, 'size2': childData.size2, 'type': childData.type, 'status': '' }));
	          }
	        });
	      });
	      var all = (0, _from2.default)(allPlans).map(function (e) {
	        return JSON.parse(e);
	      });
	      var notSold = (0, _from2.default)(notSoldPlans).map(function (e) {
	        return JSON.parse(e);
	      });
	      var clean = all.map(function (obj) {
	        return notSold.find(function (o) {
	          return o.plan === obj.plan;
	        }) || obj;
	      });
	      this.$firebaseRefs.project.child('plans').set(clean);
	    },
	    cancelUpdateUnits: function cancelUpdateUnits() {
	      projectRef = _helpers.db.ref(this.$route.path);
	      this.$bindAsObject('project', projectRef);
	      this.dialogFormVisible = false;
	    },
	    getSearchDef: function getSearchDef() {
	      return {
	        show: false,
	        placeholder: 'Search by Keyword',
	        props: ['id', 'unitnum', 'floor', 'unit', 'size', 'size', 'type', 'file', 'plate', 'price', 'status', 'view']
	      };
	    },
	    getPaginationDef: function getPaginationDef() {
	      return {
	        layout: 'total, prev, pager, next, jumper, sizes',
	        pageSize: 300,
	        pageSizes: [20, 50, 100, 150, 200, 300],
	        currentPage: 1
	      };
	    },
	    getExportActionsDef: function getExportActionsDef() {
	      var _this = this;
	
	      var columns = ['id', 'unitnum', 'floor', 'unit', 'size', 'size2', 'plan', 'type', 'file', 'plate', 'price', 'status', 'view'];
	      var columnNames = ['id', 'unitnum', 'floor', 'unit', 'size', 'size2', 'plan', 'type', 'file', 'plate', 'price', 'status', 'view'];
	
	      return {
	        width: 19,
	        def: [{
	          name: 'Export',
	          handler: function handler() {
	            var timeStamp = (0, _moment2.default)(Date.now()).format();
	            (0, _CsvExport2.default)(_this.project.units, columns, columnNames, _this.project.slug + '_' + timeStamp);
	          },
	          icon: 'plus'
	        }]
	      };
	    },
	    rowClick: function rowClick(row) {
	      var vm = this;
	      vm.dialogFormVisible = true;
	      vm.form = row;
	    }
	  }
	};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(5);
	
	var _slugify = __webpack_require__(190);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectsRef = _helpers.db.ref('projects');
	var usersRef = _helpers.db.ref('users');
	
	exports.default = {
	  name: 'projects',
	  firebase: {
	    projects: projectsRef.orderByChild('mostRecent')
	  },
	  data: function data() {
	    return {
	      admin: true,
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      userInline: {
	        displayName: '',
	        email: '',
	        password: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter you email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }],
	        name: [{ required: true, message: 'Project Name required', trigger: 'blur' }]
	      },
	      newProject: {
	        created: null,
	        edited: null,
	        slug: '',
	        name: '',
	        units: '',
	        users: ''
	      }
	    };
	  },
	
	  methods: {
	    addproject: function addproject(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var timeStamp = Date.now();
	          _this.newProject.mostRecent = -Math.abs(timeStamp);
	          _this.newProject.created = timeStamp;
	          _this.newProject.edited = timeStamp;
	          _this.newProject.slug = (0, _slugify2.default)(_this.newProject.name.toLowerCase());
	          projectsRef.push(_this.newProject);
	          _this.newProject.created = '';
	          _this.newProject.edited = '';
	          _this.newProject.slug = '';
	          _this.newProject.name = '';
	          _this.newProject.units = '';
	        } else {
	          console.log('Error with add project!');
	          return false;
	        }
	      });
	    },
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    }
	  },
	  created: function created() {
	    this.$bindAsObject('user', usersRef.child(this.auth.user.uid));
	    this.$bindAsArray('userProjects', projectsRef.orderByChild('users/' + this.auth.user.uid).equalTo(true));
	  }
	};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      ruleForm: {
	        email: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter your email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }]
	      }
	    };
	  },
	
	  methods: {
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          _this.auth.reset(_this.ruleForm.email);
	        } else {
	          console.log('error submit!!');
	          return false;
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(234);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userRef = void 0;
	var projectsRef = _helpers.db.ref('projects');
	
	exports.default = {
	  name: 'user',
	
	  firebase: {
	    projects: projectsRef
	  },
	
	  data: function data() {
	    return {
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      deleteFormVisible: false,
	      dataReady: false
	    };
	  },
	  created: function created() {
	    userRef = _helpers.db.ref(this.$route.path);
	    this.$bindAsObject('user', userRef);
	    this.$bindAsArray('userProjects', projectsRef.orderByChild('users/' + this.auth.user.uid).equalTo(true));
	    this.dataReady = true;
	  },
	
	
	  methods: {
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    },
	    updateUserRole: function updateUserRole() {
	      var userRole = this.user.isAdmin;
	      this.$firebaseRefs.user.child('isAdmin').remove();
	      this.$firebaseRefs.user.child('isAdmin').set(userRole);
	    },
	    updateUserProjects: function updateUserProjects(project, uid) {
	      var ref = this.$firebaseRefs.projects.child(project['.key']).child('users/');
	      ref.once('value').then(function (snapshot) {
	        if (snapshot.child(uid).val() === null) {
	          ref.update((0, _defineProperty3.default)({}, uid, true));
	        } else {
	          ref.update((0, _defineProperty3.default)({}, uid, project.users[uid]));
	        }
	      });
	    },
	    deleteUser: function deleteUser() {
	      this.auth.userDelete(this.user['.key']);
	    }
	  }
	
	};

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectsRef = _helpers.db.ref('projects');
	var usersRef = _helpers.db.ref('users');
	exports.default = {
	  name: 'profiles',
	  firebase: {
	    projects: projectsRef,
	    users: usersRef
	  },
	  data: function data() {
	    return {
	      auth: _helpers.authService,
	      labelPosition: 'top',
	      addUserForm: {
	        email: '',
	        pass: ''
	      },
	      rules: {
	        email: [{ required: true, message: 'Please enter your email address', trigger: 'blur' }, { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }],
	        pass: [{ required: true, message: 'Please enter your password', trigger: 'blur' }, { min: 6, message: 'Your password is too short!' }]
	      }
	    };
	  },
	
	  methods: {
	    prettyDate: function prettyDate(date) {
	      return (0, _moment2.default)(date).format('MMMM Do YYYY, h:mm:ss a');
	    },
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var email = _this.addUserForm.email;
	          var pass = _this.addUserForm.pass;
	          _this.auth.userCreate(email, pass);
	          _this.addUserForm.email = '';
	          _this.addUserForm.pass = '';
	        } else {
	          console.log('There was an error!');
	          return false;
	        }
	      });
	    }
	  },
	  created: function created() {
	    this.$bindAsObject('user', usersRef.child(this.auth.user.uid));
	  }
	};

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 74,
		"./af.js": 74,
		"./ar": 81,
		"./ar-dz": 75,
		"./ar-dz.js": 75,
		"./ar-kw": 76,
		"./ar-kw.js": 76,
		"./ar-ly": 77,
		"./ar-ly.js": 77,
		"./ar-ma": 78,
		"./ar-ma.js": 78,
		"./ar-sa": 79,
		"./ar-sa.js": 79,
		"./ar-tn": 80,
		"./ar-tn.js": 80,
		"./ar.js": 81,
		"./az": 82,
		"./az.js": 82,
		"./be": 83,
		"./be.js": 83,
		"./bg": 84,
		"./bg.js": 84,
		"./bn": 85,
		"./bn.js": 85,
		"./bo": 86,
		"./bo.js": 86,
		"./br": 87,
		"./br.js": 87,
		"./bs": 88,
		"./bs.js": 88,
		"./ca": 89,
		"./ca.js": 89,
		"./cs": 90,
		"./cs.js": 90,
		"./cv": 91,
		"./cv.js": 91,
		"./cy": 92,
		"./cy.js": 92,
		"./da": 93,
		"./da.js": 93,
		"./de": 96,
		"./de-at": 94,
		"./de-at.js": 94,
		"./de-ch": 95,
		"./de-ch.js": 95,
		"./de.js": 96,
		"./dv": 97,
		"./dv.js": 97,
		"./el": 98,
		"./el.js": 98,
		"./en-au": 99,
		"./en-au.js": 99,
		"./en-ca": 100,
		"./en-ca.js": 100,
		"./en-gb": 101,
		"./en-gb.js": 101,
		"./en-ie": 102,
		"./en-ie.js": 102,
		"./en-nz": 103,
		"./en-nz.js": 103,
		"./eo": 104,
		"./eo.js": 104,
		"./es": 106,
		"./es-do": 105,
		"./es-do.js": 105,
		"./es.js": 106,
		"./et": 107,
		"./et.js": 107,
		"./eu": 108,
		"./eu.js": 108,
		"./fa": 109,
		"./fa.js": 109,
		"./fi": 110,
		"./fi.js": 110,
		"./fo": 111,
		"./fo.js": 111,
		"./fr": 114,
		"./fr-ca": 112,
		"./fr-ca.js": 112,
		"./fr-ch": 113,
		"./fr-ch.js": 113,
		"./fr.js": 114,
		"./fy": 115,
		"./fy.js": 115,
		"./gd": 116,
		"./gd.js": 116,
		"./gl": 117,
		"./gl.js": 117,
		"./gom-latn": 118,
		"./gom-latn.js": 118,
		"./he": 119,
		"./he.js": 119,
		"./hi": 120,
		"./hi.js": 120,
		"./hr": 121,
		"./hr.js": 121,
		"./hu": 122,
		"./hu.js": 122,
		"./hy-am": 123,
		"./hy-am.js": 123,
		"./id": 124,
		"./id.js": 124,
		"./is": 125,
		"./is.js": 125,
		"./it": 126,
		"./it.js": 126,
		"./ja": 127,
		"./ja.js": 127,
		"./jv": 128,
		"./jv.js": 128,
		"./ka": 129,
		"./ka.js": 129,
		"./kk": 130,
		"./kk.js": 130,
		"./km": 131,
		"./km.js": 131,
		"./kn": 132,
		"./kn.js": 132,
		"./ko": 133,
		"./ko.js": 133,
		"./ky": 134,
		"./ky.js": 134,
		"./lb": 135,
		"./lb.js": 135,
		"./lo": 136,
		"./lo.js": 136,
		"./lt": 137,
		"./lt.js": 137,
		"./lv": 138,
		"./lv.js": 138,
		"./me": 139,
		"./me.js": 139,
		"./mi": 140,
		"./mi.js": 140,
		"./mk": 141,
		"./mk.js": 141,
		"./ml": 142,
		"./ml.js": 142,
		"./mr": 143,
		"./mr.js": 143,
		"./ms": 145,
		"./ms-my": 144,
		"./ms-my.js": 144,
		"./ms.js": 145,
		"./my": 146,
		"./my.js": 146,
		"./nb": 147,
		"./nb.js": 147,
		"./ne": 148,
		"./ne.js": 148,
		"./nl": 150,
		"./nl-be": 149,
		"./nl-be.js": 149,
		"./nl.js": 150,
		"./nn": 151,
		"./nn.js": 151,
		"./pa-in": 152,
		"./pa-in.js": 152,
		"./pl": 153,
		"./pl.js": 153,
		"./pt": 155,
		"./pt-br": 154,
		"./pt-br.js": 154,
		"./pt.js": 155,
		"./ro": 156,
		"./ro.js": 156,
		"./ru": 157,
		"./ru.js": 157,
		"./sd": 158,
		"./sd.js": 158,
		"./se": 159,
		"./se.js": 159,
		"./si": 160,
		"./si.js": 160,
		"./sk": 161,
		"./sk.js": 161,
		"./sl": 162,
		"./sl.js": 162,
		"./sq": 163,
		"./sq.js": 163,
		"./sr": 165,
		"./sr-cyrl": 164,
		"./sr-cyrl.js": 164,
		"./sr.js": 165,
		"./ss": 166,
		"./ss.js": 166,
		"./sv": 167,
		"./sv.js": 167,
		"./sw": 168,
		"./sw.js": 168,
		"./ta": 169,
		"./ta.js": 169,
		"./te": 170,
		"./te.js": 170,
		"./tet": 171,
		"./tet.js": 171,
		"./th": 172,
		"./th.js": 172,
		"./tl-ph": 173,
		"./tl-ph.js": 173,
		"./tlh": 174,
		"./tlh.js": 174,
		"./tr": 175,
		"./tr.js": 175,
		"./tzl": 176,
		"./tzl.js": 176,
		"./tzm": 178,
		"./tzm-latn": 177,
		"./tzm-latn.js": 177,
		"./tzm.js": 178,
		"./uk": 179,
		"./uk.js": 179,
		"./ur": 180,
		"./ur.js": 180,
		"./uz": 182,
		"./uz-latn": 181,
		"./uz-latn.js": 181,
		"./uz.js": 182,
		"./vi": 183,
		"./vi.js": 183,
		"./x-pseudo": 184,
		"./x-pseudo.js": 184,
		"./yo": 185,
		"./yo.js": 185,
		"./zh-cn": 186,
		"./zh-cn.js": 186,
		"./zh-hk": 187,
		"./zh-hk.js": 187,
		"./zh-tw": 188,
		"./zh-tw.js": 188
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 314;


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMTIzLjkzNyAxNTguODc5Ij48ZyBmaWxsPSIjRkZGIj48cGF0aCBkPSJNNDUzLjg5NyAxNTguNjgyVjIzLjE1MmwuMTIzLTQuMjJjLS41OTQgMS4zMi0uOTk4IDIuMTg4LTEuMjI5IDIuNjM2bC0zLjU0MyA3LjI5OC02My44NzIgMTI5LjgxNmgtMjIuNjQ4TDI5OC43MjEgMzAuMzY1bC0zLjY4Ni03LjE5NS0xLjIxLTIuNzA0LjExMSAzLjQ0Ny4wMDEgMTM0Ljc2OWgtMjMuNTc2VjBIMzAxLjJjLjI0Ny4wMTIgNC4zNTkuMjcxIDcuNDk2IDIuODAyIDIuMzE1IDEuODQ2IDQuMTUgNS4yNzkgNC4yMjggNS40MjZsNDYuMDMgOTMuNDc5IDcuOTMxIDE2LjM3MSAzLjk1OSA4LjEwNyAyLjkzNCA2LjIxNyAyLjkyOS02LjIwMWMxLjk1LTMuOTc3IDMuMTg5LTYuNjA1IDMuNzkyLTguMDU3bDguMTAyLTE2LjMxMiA0NS4xMTMtOTIuMjI5Yy4xOTUtLjQ3NiAxLjUyOC0zLjUzNCA0LjY1Mi02LjIwOEM0NDEuOTg5LjMxNCA0NDYuNTQuMDE0IDQ0Ni43MzEuMDAzTDQ3Ny40NjUgMHYxNTguNjgyaC0yMy41Njh6TTU5My42NjggMjUuOTI3Yy0uMTctLjQ5NS0xLjU1MS0zLjAyMS0zLjI5OS00LjgzMS0yLjU0MS0yLjYyNi00Ljg5Ni0zLjQ0OC02LjE0NC0zLjQwNGwtLjU1My0uMDAxaC0uODAzYy0uMjk1IDAtLjUwMi0uMDMxLS42NjYgMGgtMTQuNDhjLTEuMjQ4LS4wNDMtMy42MDQuNzc5LTYuMTQ1IDMuNDA1LTEuNzUyIDEuODEtMy4xMzEgNC4zMzYtMy4zMDEgNC44MzFsLTU4LjA5NCAxMzIuNzU1aDIyLjUzNUw1NzMuNzIgNDAuNTQ4cy42MDQtMS41MTYgMi4yNTItMS41MjFjMS42NS4wMDcgMi4yNTQgMS41MjEgMi4yNTQgMS41MjFsMjYuMDE2IDU5LjM0MmgtNDYuNTA4bC02LjIwOSAxNC4zNTRoNTguOTk2bDE5LjQ0NSA0NC40MzhoMjIuMzA1TDU5My42NjggMjUuOTI3ek03ODEuNDM2IDE1OC42ODJsLTEyLjYyMy0yNi4zMzJjLTEuNDczLTIuOTItMi43NjItNS43NjYtNC4wMDgtOC41MTktNS41MTItMTIuMTYyLTkuNDkyLTIwLjk1LTIyLjI2OC0yMC45NWgtNDAuNDU1Vjg3LjE1M2g0My41MjVjMTMuODM4IDAgMjMuMzQ0LTEuNzQ4IDI4LjI1Ni01LjE5NyA0Ljc2Mi0zLjM0MyA3LjE3OC05Ljg2NSA3LjE3OC0xOS4zODkgMC0xMi4xMDUtMS44MDUtMjAuMDI3LTUuMzYxLTIzLjU0Ni0zLjU1NS0zLjUxOS0xMS41Mi01LjMwMy0yMy42NzgtNS4zMDNoLTU4Ljc1djEyNC45NjNoLTIxLjI1NnYtMTQwLjdoNzkuNzU0YzE3Ljk1OSAwIDMwLjg0IDMuMDY0IDM4LjI4NSA5LjEwOCA3LjUzOSA2LjExNCAxMS4zNjEgMTYuNzU3IDExLjM2MSAzMS42MyAwIDEzLjIxMS0yLjAzNSAyMi4yMTEtNi4yMjEgMjcuNTE2LTMuMzk2IDQuMzI3LTkuMzk4IDExLjk3My0xOS42NDEgMTMuNjEzIDIuMjk1IDIuNDk4IDMuNjExIDUuMDczIDQuNzgzIDcuMzY3LjE4LjM1LjM1NS42OTMuNTMxIDEuMDI5IDIuNjg1IDUuNDcxIDUuMTA5IDEwLjU1MyA5LjUxIDE5Ljc3OCAzLjI0NCA2LjgwMiA3LjU0MyAxNS44MTUgMTMuNzcgMjguODAzbC44ODkgMS44NTVoLTIzLjU4MXpNODkwLjk5MSAxNTguNjgyYy0yOC4yNiAwLTQ1Ljc5Ny00LjE5My01My42MTUtMTIuODE4LTcuNzg3LTguNTkxLTExLjU3Mi0yNy45NDYtMTEuNTcyLTU5LjE2OCAwLTI0LjI5My44NDgtMzkuMTc4IDIuNTg4LTQ1LjUwMiAxLjc2Ni02LjQ1NyA2LjgzNC0xMi4yNzYgMTUuMDYxLTE3LjI5NyA5LjYzMy01Ljg0NSAyOS42NDYtOC42ODUgNjEuMTg5LTguNjg1IDIxLjQ4NCAwIDM1LjYyMyAyLjc3MSA0My4yMjEgOC40NzIgNy44MzYgNS45MDMgMTEuNTYzIDExLjQ3IDExLjU2MyAyNy4xNDJ2MS4yOTVIOTM4LjM1di0xLjI5NWMwLTEwLjkyMi0yLjI3NS0xMi41OTgtNi4wNDUtMTUuMzc1LTQuMDUxLTIuOTg2LTEzLjYwMi00LjUwMi0yOC4zODUtNC41MDItMjYuMTcgMC00Mi4zMDMgMS44MDMtNDcuOTQ5IDUuMzU3LTUuNDM2IDMuNDM4LTguMTkzIDEzLjQ0OS04LjE5MyAyOS43NTYgMCAzOC4zNTQgMS45MjggNjEuMDY5IDUuNzI3IDY3LjUxNCAzLjY3MiA2LjIyMyAxNi45IDkuMzc4IDM5LjMxOCA5LjM3OCAyMS41NDcgMCAzNS4xMjctMS40MSA0MC4zNjEtNC4xODkgNS4wMjktMi42OTkgNy40NDktNC40OTQgNy40NDktMTUuNjg2di0xLjI5N2gyMS4wNzR2MS4yOTdjMCAxOC43ODQtMy45NDMgMjMuMjU3LTEyLjMxNCAyOC4zODgtNy45MiA0Ljg1Ni0yNy4wMjMgNy4yMTUtNTguNDAyIDcuMjE1ek0xMDY1LjMzMyAyNS45MjdjLS4xNy0uNDk1LTEuNTUxLTMuMDIxLTMuMjk5LTQuODMxLTIuNTQxLTIuNjI2LTQuODk2LTMuNDQ4LTYuMTQ1LTMuNDA0bC0uNTUzLS4wMDFoLS44MDNjLS4yOTUgMC0uNTAyLS4wMzEtLjY2NiAwaC0xNC40OGMtMS4yNDgtLjA0My0zLjYwNC43NzktNi4xNDUgMy40MDUtMS43NTIgMS44MS0zLjEzMSA0LjMzNi0zLjMwMSA0LjgzMWwtNTguMDk0IDEzMi43NTVoMjIuNTM1bDUxLjAwMi0xMTguMTM0cy42MDQtMS41MTYgMi4yNTItMS41MjFjMS42NS4wMDcgMi4yNTQgMS41MjEgMi4yNTQgMS41MjFsMjYuMDE2IDU5LjM0MkgxMDI5LjRsLTYuMjA5IDE0LjM1NGg1OC45OTZsMTkuNDQ1IDQ0LjQzOGgyMi4zMDVsLTU4LjYwNC0xMzIuNzU1eiIvPjwvZz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAuNjY1djE1OC4yMTRoMjA3LjEwM1YuNjY1SDB6bTUzLjA0IDExNS43MjdjLTIuNjkxIDIuMjg5LTYuMDcyIDIuNTEtNi4yMTMgMi41MkgzNC40NjVsMzUuMjg5LTcyLjAwOWMuMTQ2LS4zNTQgMS4xMzUtMi42MjYgMy40NTctNC42MTIgMi42OTEtMi4yODkgNi4wNzItMi41MTIgNi4yMTMtMi41MmwxMi4zNjItLjAwMS0zNS4yOSA3Mi4wMWMtLjE0NC4zNTMtMS4xMzUgMi42MjQtMy40NTYgNC42MTJ6bTQwLjQ1NC0uMDAyYy0yLjY5MiAyLjI4OS02LjA3MiAyLjUxMi02LjIxMyAyLjUybC0xMi4zNjIuMDAyIDI5LjA3NS01OS4zODJjLjE0NS0uMzU0IDEuMTM2LTIuNjI2IDMuNDU1LTQuNjExIDIuNjkzLTIuMjg5IDYuMDcyLTIuNTEzIDYuMjE1LTIuNTE4bDEyLjM2LS4wMDEtMjkuMDc0IDU5LjM4Yy0uMTQ2LjM1Mi0xLjEzNiAyLjYyNC0zLjQ1NiA0LjYxem00My44MTgtNC42MWMtLjE0My4zNTItMS4xMzYgMi42MjQtMy40NTUgNC42MTEtMi42OTIgMi4yODktNi4wNzIgMi41MS02LjIxNiAyLjUyaC0xMi4zNThsMzUuMjg4LTcyLjAwOWMuMTQ2LS4zNTQgMS4xMzUtMi42MjYgMy40NTctNC42MTIgMi42OTEtMi4yODkgNi4wNzItMi41MTIgNi4yMTMtMi41MmwxMi4zNjEtLjAwMS0zNS4yOSA3Mi4wMTF6Ii8+PC9zdmc+"

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(293)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(219),
	  /* template */
	  __webpack_require__(332),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(291)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(220),
	  /* template */
	  __webpack_require__(330),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(290)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(221),
	  /* template */
	  __webpack_require__(329),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(298)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(222),
	  /* template */
	  __webpack_require__(337),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(294)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(223),
	  /* template */
	  __webpack_require__(333),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(297)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(224),
	  /* template */
	  __webpack_require__(336),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(299)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(225),
	  /* template */
	  __webpack_require__(338),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(296)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(226),
	  /* template */
	  __webpack_require__(335),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(295)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(227),
	  /* template */
	  __webpack_require__(334),
	  /* scopeId */
	  "data-v-7c92c98b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(292)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(228),
	  /* template */
	  __webpack_require__(331),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "headerWrapper"
	  }, [_c('header', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('el-menu', {
	    staticClass: "el-menu-header",
	    attrs: {
	      "theme": "dark",
	      "default-active": _vm.activeIndex,
	      "mode": "horizontal"
	    }
	  }, [_c('el-menu-item', {
	    staticClass: "home-link",
	    attrs: {
	      "index": "1"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/",
	      "exact": ""
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(317)
	    }
	  })])], 1), _vm._v(" "), (_vm.auth.user !== null) ? _c('el-menu-item', {
	    attrs: {
	      "index": "2"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/projects"
	    }
	  }, [_c('span', [_vm._v("Projects")])])], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user !== null) ? _c('el-submenu', {
	    attrs: {
	      "index": "5"
	    }
	  }, [_c('template', {
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.auth.user.email))]), _vm._v(" "), (_vm.userMeta.isAdmin == true) ? _c('el-menu-item', {
	    attrs: {
	      "index": "5-1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('/users')
	      }
	    }
	  }, [_vm._v("Manage Users")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "index": "5-2"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logOut()
	      }
	    }
	  }, [_vm._v("Logout")])], 2) : _vm._e()], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataReady) ? _c('div', {
	    staticClass: "container page-container"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('h1', [_vm._v("Confirm new password")])])], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user.isAdmin) ? _c('div', {
	    staticClass: "container page-container",
	    attrs: {
	      "id": "profile-form"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('h1', [_vm._v("Add a User")]), _vm._v(" "), _c('el-form', {
	    ref: "addUserForm",
	    staticClass: "ruleForm",
	    attrs: {
	      "model": _vm.addUserForm,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition,
	      "label-width": "100px"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.addUserForm.email),
	      callback: function($$v) {
	        _vm.addUserForm.email = $$v
	      },
	      expression: "addUserForm.email"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "pass"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.addUserForm.pass),
	      callback: function($$v) {
	        _vm.addUserForm.pass = $$v
	      },
	      expression: "addUserForm.pass"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-form-item', [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.submitForm('addUserForm')
	      }
	    }
	  }, [_vm._v("Add User")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('h1', [_vm._v("Manage Users")])])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, _vm._l((_vm.users), function(user, index) {
	    return _c('el-col', {
	      key: user.email,
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "md": 12,
	        "lg": 12
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "text item"
	    }, [_c('span', {
	      staticClass: "user-title"
	    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.$router.push('/users/' + user['.key'])
	        }
	      }
	    }, [_vm._v("Manage")]), _vm._v(" "), _c('div', {
	      staticClass: "cf"
	    }), _vm._v(" "), (user.isAdmin !== false) ? _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (user.isAdmin == false) ? _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Client")]) : _vm._e()], 1)])], 1)
	  }))], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('app-header'), _vm._v(" "), (_vm.auth.user == null) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in",
	      "appear-class": "fade"
	    }
	  }, [(_vm.auth.user == null) ? _c('router-view', {
	    attrs: {
	      "name": "entry"
	    }
	  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user !== null) ? _c('div', [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in",
	      "appear-class": "fade"
	    }
	  }, [(_vm.auth.user !== null) ? _c('router-view') : _vm._e()], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "not-found"
	    }
	  }, [_c('h1', [_vm._v("Not found ... ")])])
	}]}

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataReady) ? _c('div', {
	    staticClass: "container page-container"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('h1', {
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
	    on: {
	      "change": _vm.updateUserRole
	    },
	    model: {
	      value: (_vm.user.isAdmin),
	      callback: function($$v) {
	        _vm.user.isAdmin = $$v
	      },
	      expression: "user.isAdmin"
	    }
	  }, [_vm._v(" Admin")]), _c('br'), _vm._v(" "), (_vm.user.isAdmin !== true) ? _c('div', {
	    staticClass: "project-select"
	  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), (_vm.projects) ? _c('ul', _vm._l((_vm.projects), function(project, index) {
	    return _c('li', [_c('el-checkbox', {
	      on: {
	        "change": function($event) {
	          _vm.updateUserProjects(project, _vm.user['.key'])
	        }
	      },
	      model: {
	        value: (project.users[_vm.user['.key']]),
	        callback: function($$v) {
	          var $$exp = project.users,
	            $$idx = _vm.user['.key'];
	          if (!Array.isArray($$exp)) {
	            project.users[_vm.user['.key']] = $$v
	          } else {
	            $$exp.splice($$idx, 1, $$v)
	          }
	        },
	        expression: "project.users[user['.key']]"
	      }
	    }, [_vm._v(" " + _vm._s(project.name))])], 1)
	  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "size": "large",
	      "icon": "arrow-left"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.$router.push('/users')
	      }
	    }
	  }, [_vm._v(" Back to Users")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Are You Sure You Want To Delete This User?",
	      "visible": _vm.deleteFormVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.deleteFormVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    attrs: {
	      "inline": true,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('p', [_vm._v("You will also need to delete the user in the "), _c('a', {
	    staticClass: "link-out",
	    attrs: {
	      "href": "http://console.firebase.google.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Firebase console")]), _vm._v(".")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = false
	      }
	    }
	  }, [_vm._v("No Way, Get Me Out Of Here!")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteUser()
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "reset-form"
	    }
	  }, [_c('el-form', {
	    ref: "ruleForm",
	    staticClass: "ruleForm",
	    attrs: {
	      "model": _vm.ruleForm,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition,
	      "label-width": "100px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.ruleForm.email),
	      callback: function($$v) {
	        _vm.ruleForm.email = $$v
	      },
	      expression: "ruleForm.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.submitForm('ruleForm')
	      }
	    }
	  }, [_vm._v("Reset password")]), _vm._v(" "), _c('router-link', {
	    staticClass: "alt-link",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Back to Login")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataReady) ? _c('div', {
	    staticClass: "container page-container"
	  }, [_c('h1', {
	    staticClass: "project"
	  }, [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('p', {
	    staticClass: "edited"
	  }, [_vm._v("Edited: "), _c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.prettyDate(_vm.project.edited)))]), _c('br'), _vm._v("\n  Created: "), _c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.prettyDate(_vm.project.created)))])]), _vm._v(" "), (_vm.user.isAdmin) ? _c('div', {
	    staticClass: "add-project"
	  }, [_c('el-form', {
	    staticClass: "form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.formInline,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Edit Project Name"
	    }
	  }, [_c('el-input', {
	    on: {
	      "change": _vm.updateName
	    },
	    model: {
	      value: (_vm.project.name),
	      callback: function($$v) {
	        _vm.project.name = $$v
	      },
	      expression: "project.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Add Project Data"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "file",
	      "accept": ".csv"
	    },
	    on: {
	      "change": _vm.updateFile
	    }
	  })]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": " "
	    }
	  }, [_c('el-button', {
	    staticClass: "btn-delete",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = true
	      }
	    }
	  }, [_vm._v("Delete Project "), _c('i', {
	    staticClass: "el-icon-delete el-icon-right"
	  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.project.units) ? _c('data-tables', {
	    attrs: {
	      "data": _vm.project.units,
	      "actions-def": _vm.getExportActionsDef(),
	      "pagination-def": _vm.getPaginationDef(),
	      "search-def": _vm.getSearchDef(),
	      "has-action-col": false
	    },
	    on: {
	      "row-click": _vm.rowClick,
	      "filtered-data": _vm.handleFilterDataChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "unitnum",
	      "label": "Unit No.",
	      "sortable": "custom",
	      "width": 125
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "size",
	      "label": "Size"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "size2",
	      "label": "Size 2"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "plan",
	      "label": "Plan"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "type",
	      "label": "Type",
	      "width": 450
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "price",
	      "label": "Price"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "status",
	      "label": "Status"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "visible": _vm.dialogFormVisible,
	      "close-on-click-modal": false,
	      "close-on-press-escape": false,
	      "show-close": false
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogFormVisible = $event
	      }
	    }
	  }, [_c('span', {
	    staticClass: "dialog-title",
	    slot: "title"
	  }, [_vm._v("\n      Edit Unit " + _vm._s(_vm.form.unitnum) + "\n    ")]), _vm._v(" "), _c('el-form', {
	    attrs: {
	      "model": _vm.form,
	      "inline": true,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Size",
	      "prop": "size"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "auto-complete": "off"
	    },
	    model: {
	      value: (_vm.form.size),
	      callback: function($$v) {
	        _vm.form.size = $$v
	      },
	      expression: "form.size"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Size 2",
	      "prop": "size2"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "auto-complete": "off"
	    },
	    model: {
	      value: (_vm.form.size2),
	      callback: function($$v) {
	        _vm.form.size2 = $$v
	      },
	      expression: "form.size2"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Price"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "auto-complete": "off"
	    },
	    model: {
	      value: (_vm.form.price),
	      callback: function($$v) {
	        _vm.form.price = $$v
	      },
	      expression: "form.price"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Status"
	    }
	  }, [_c('el-select', {
	    model: {
	      value: (_vm.form.status),
	      callback: function($$v) {
	        _vm.form.status = $$v
	      },
	      expression: "form.status"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.cancelUpdateUnits()
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.updateUnits
	    }
	  }, [_vm._v("Update")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Are You Sure You Want To Delete This Project?",
	      "visible": _vm.deleteFormVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.deleteFormVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    attrs: {
	      "model": _vm.form,
	      "inline": true,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.deleteFormVisible = false
	      }
	    }
	  }, [_vm._v("No Way, Get Me Out Of Here!")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteProject()
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.auth.user == null) ? _c('div', {
	    attrs: {
	      "id": "login-form"
	    }
	  }, [_c('el-form', {
	    ref: "loginForm",
	    staticClass: "loginForm",
	    attrs: {
	      "model": _vm.loginForm,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition,
	      "label-width": "100px"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.submitForm('loginForm')
	      }
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.loginForm.email),
	      callback: function($$v) {
	        _vm.loginForm.email = $$v
	      },
	      expression: "loginForm.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "pass"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.loginForm.pass),
	      callback: function($$v) {
	        _vm.loginForm.pass = $$v
	      },
	      expression: "loginForm.pass"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitForm('loginForm')
	      }
	    }
	  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
	    staticClass: "alt-link",
	    attrs: {
	      "to": "reset"
	    }
	  }, [_vm._v("Reset Password")])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container page-container"
	  }, [_c('h1', [_vm._v("Your Projects")]), _vm._v(" "), (_vm.user.isAdmin) ? _c('div', {
	    staticClass: "add-project"
	  }, [_c('el-form', {
	    ref: "addProjectForm",
	    staticClass: "form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.newProject,
	      "rules": _vm.rules,
	      "label-position": _vm.labelPosition
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Project Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Name"
	    },
	    model: {
	      value: (_vm.newProject.name),
	      callback: function($$v) {
	        _vm.newProject.name = $$v
	      },
	      expression: "newProject.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": " "
	    }
	  }, [_c('el-button', {
	    staticClass: "btn-add",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addproject('addProjectForm')
	      }
	    }
	  }, [_vm._v("Add  "), _c('i', {
	    staticClass: "el-icon-plus el-icon-right"
	  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin !== true) ? _c('div', [(_vm.auth.user !== null) ? _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, _vm._l((_vm.userProjects), function(project, index) {
	    return _c('el-col', {
	      key: project.name,
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "md": 12,
	        "lg": 12
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "text item"
	    }, [_c('span', {
	      staticClass: "project-title"
	    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.$router.push('/projects/' + project['.key'])
	        }
	      }
	    }, [_vm._v("Manage")]), _vm._v(" "), _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Edited: " + _vm._s(_vm.prettyDate(project.edited)))])], 1)])], 1)
	  })) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin == true) ? _c('div', [(_vm.auth.user !== null) ? _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, _vm._l((_vm.projects), function(project, index) {
	    return _c('el-col', {
	      key: project.name,
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "md": 12,
	        "lg": 12
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "text item"
	    }, [_c('span', {
	      staticClass: "project-title"
	    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.$router.push('/projects/' + project['.key'])
	        }
	      }
	    }, [_vm._v("Manage")]), _vm._v(" "), _c('span', {
	      staticClass: "edited"
	    }, [_vm._v("Edited: " + _vm._s(_vm.prettyDate(project.edited)))])], 1)])], 1)
	  })) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.b3c290781a46edf492c5.js